import { serviceProvidersOptionData } from 'helpers/adapter';
import domainStore from 'store/domainStore';

const tableOptions = {
  fields: [
    {
      id: 'id',
      label: 'table.wineList.id',
      type: 'text',
      sortable: true,
      width: '10%',
      show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
    },
    {
      id: 'partnerName',
      orderField: 'include_serviceProviders_name',
      label: 'table.wineList.partner',
      type: 'text',
      sortable: true,
      width: '20%',
      show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
    },
    { id: 'menuName', label: 'table.wineList.name', type: 'text', sortable: true, width: '30%' },
    {
      id: 'menuItemsCount',
      label: 'table.wineList.itemsCount',
      type: 'text',
      sortable: false,
      width: '15%',
      textAlign: 'right',
      headAlign: 'right',
    },
    {
      id: 'shouldResetWineRating',
      label: 'table.wineList.resetWineRating',
      type: 'bool',
      showIcon: false,
      sortable: true,
      width: '15%',
      textAlign: 'right',
      headAlign: 'right',
    },
    {
      id: 'isDefault',
      label: 'table.wineList.isDefault',
      type: 'bool',
      showIcon: false,
      sortable: true,
      textAlign: 'right',
      headAlign: 'right',
      width: '15%',
    },
    {
      id: 'createdAt',
      label: 'table.wineList.createdDate',
      type: 'text',
      sortable: true,
      width: '15%',
      textAlign: 'right',
      headAlign: 'right',
    },
  ],
  rowsPerPageOptions: [5, 10, 25, 50, 100],
  filterFields: [
    {
      id: 'serviceProviderId_in',
      label: 'wineLists.filter.partner',
      type: 'custom-multi-autocomplete',
      options: domainStore.getSPListNames,
      adapterCallback: serviceProvidersOptionData,
      withoutParams: true,
      fromStore: true,
      priority: 1,
      optionsWithCheckbox: true,
      selectedClassName: 'colorizeSelected',
      sortBySelected: true,
      show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
    },
  ],
  searchFields: ['menuName'],
};

export default tableOptions;
